module.exports = __webpack_public_path__ + "static/img/phy-upper-limit.52ec81a8.png";